import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { blobToBase64String, base64StringToBlob } from 'blob-util';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-param-contrat',
  templateUrl: './param-contrat.component.html',
  styleUrls: ['./param-contrat.component.scss'],
})
export class ParamContratComponent implements OnInit {
  @ViewChild(AvtListesComponent, { static: false })
  listeContratComponen: AvtListesComponent;
  listBtnContrat: Array<any> = [
    {
      name: 'modifier',
      class: 'colorBlue',
      text: 'Enregistrer',
      disabled: false,
      icon: 'save',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
  ];
  data;
  exist = true;
  Columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Code',
        Lg_Code: '',
        TableRD_Des: 'Code',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Type',
        Lg_Code: '',
        TableRD_Des: 'Type',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 2,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        dataSelect: [],
        valueSelect: 'DiverSys_Index',
        textSelect: 'DiverSys_Titre',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Description',
        Lg_Code: '',
        TableRD_Des: 'Déscription',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Description1',
        Lg_Code: '',
        TableRD_Des: 'Désignation',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 4,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Fin',
        Lg_Code: '',
        TableRD_Des: 'Fin Contrat',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 5,
        TableRD_Type: 1,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Plein',
        Lg_Code: '',
        TableRD_Des: 'Téléchargé Plein.T',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 7,
        TableRD_Type: 103,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        TableRD_Icon: 'cloud_download',
        TableRD_TooltipText: '',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoUploadContrat_Plein',
        Lg_Code: '',
        TableRD_Des: 'Importé Plein.T',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 8,
        TableRD_Type: 8,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        TableRD_Icon: '',
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoContrat_Partiel',
        Lg_Code: '',
        TableRD_Des: 'Téléchargé Temps.P',
        TableRD_Largeur: 80,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 10,
        TableRD_Type: 103,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        TableRD_Icon: 'cloud_download',
        TableRD_TooltipText: 'Téléchargé',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'PersoUploadContrat_Partiel',
        Lg_Code: '',
        TableRD_Des: 'Importé Temps.P',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: null,
        TableRD_Alligement: 0,
        TableRD_Ordre: 11,
        TableRD_Type: 8,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        TableRD_Icon: '',
      },
    ],
  };
  disabledBtnAjouter: boolean = false;
  PersoContrat;
  listeTypeContratPerso;
  listeTypeContratPersoBrut;
  listeTypeContratPersoBrutIsLoadet: boolean = false;
  initDocPersoContrat_Partiel;
  initDocPersoContrat_Plein;
  selectedRow;
  ListeAllDocumentContrat = [];
  ListeAllDocumentContratIsLoadet: boolean = false;
  allContratIsLoadet: boolean = false;
  disabledTypeColl: boolean = false;
  allContrat = [];
  listeType = [];
  listeTypeContratDiverSis = [];
  constructor(public generalService: GeneralService) {}

  ngOnInit() {
    this.data = {};
    this.getInitContrat();
    this.getListeAllDocumentContrat(false, false);
    this.getAllContrat(false);
  }
  getAllContrat(getListeDocumentContratPerso: boolean) {
    this.generalService
      .rechercheTable(globalUrls.urlListeContrat)
      .subscribe((data) => {
        this.allContrat = data;
        this.allContratIsLoadet = true;
        if (this.PersoContrat != undefined) this.setPersoContrat_Code();
        if (getListeDocumentContratPerso)
          this.getListeDocumentContratPerso(this.data.Perso_Type, true);
      });
  }
  ajouter(form) {
    if (this.allContratIsLoadet) {
      var listeContrat = this.allContrat.filter((contrat) => {
        return contrat.Perso_TypePerso == this.data.Perso_TypePerso;
      });
      if (
        listeContrat.find((contrat) => {
          contrat.PersoContrat_Type == this.data.PersoContrat_Type;
        }) == undefined
      ) {
        if (form.form.valid) {
          this.exist = false;
          this.disabledBtnAjouter = true;
          if (this.data.PersoContrat_Fin) this.data.PersoContrat_Fin = 1;
          else this.data.PersoContrat_Fin = 0;
          this.data.PersoContrat_Partiel = '';
          this.data.PersoContrat_Plein = '';
          this.enregistrer(this.PersoContrat);
        }
      } else
        this.generalService.dialogSuccess(
          'Le code ou/et le type de contrat saisi existe déjà',
          false
        );
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  getInitContrat() {
    this.generalService
      .rechercheTable(globalUrls.urlpersocontrat)
      .subscribe((data) => {
        this.PersoContrat = data;
        this.data = data.PersoContrat[0];
        if (this.allContratIsLoadet) this.setPersoContrat_Code();
      });
  }
  onPersoTypePersoChange(Perso_TypePerso: number) {
    if (
      this.listeTypeContratPersoBrutIsLoadet &&
      this.ListeAllDocumentContratIsLoadet
    ) {
      this.setListeTypeContratDiverSis(Perso_TypePerso);
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  filterListeTypeContratPersoByPersoTypePerso() {
    var listeTypeContratPerso = [];
    this.listeTypeContratDiverSis.forEach((contraDiverSis) => {
      var c = this.listeTypeContratPerso.filter((contra) => {
        return contra.PersoContrat_Type == contraDiverSis.DiverSys_Index;
      });
      if (c.length > 0) listeTypeContratPerso = listeTypeContratPerso.concat(c);
    });
    return listeTypeContratPerso;
  }
  setListeContratComponen(listeTypeContratPerso) {
    listeTypeContratPerso = this.setNameDocContratToListeTypeContrat(
      listeTypeContratPerso
    );
    this.listeContratComponen.setDataSource(listeTypeContratPerso);
  }
  setListeTypeContratDiverSis(Perso_TypePerso: number) {
    this.exist = false;
    var paramPerso_TypePerso = '';
    if (this.data.Perso_Type == '0') paramPerso_TypePerso = 'COL04';
    if (this.data.Perso_Type == '2') paramPerso_TypePerso = 'COL10';
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + paramPerso_TypePerso)
      .subscribe((data) => {
        data = this.generalService.sort(data.DiverSys, 'DiverSys_Titre');
        this.exist = true;
        this.listeTypeContratDiverSis = data.filter((contrat) => {
          return contrat.DiverSys_Group == Perso_TypePerso.toString();
        });
        this.Columns.TableRD[1].dataSelect = this.listeTypeContratDiverSis;
        var listeTypeContratPerso =
          this.filterListeTypeContratPersoByPersoTypePerso();
        this.setListeContratComponen(listeTypeContratPerso);
      });
  }
  onPersoTypeChange(Perso_Type: string) {
    var paramPerso_Type = '';
    if (Perso_Type == '0') paramPerso_Type = 'col01';
    if (Perso_Type == '2') paramPerso_Type = 'COL07';
    this.listeType = [];
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=' + paramPerso_Type)
      .subscribe((data) => {
        this.listeType = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });

    this.getListeDocumentContratPerso(Perso_Type, false);
  }
  getListeDocumentContratPerso(
    Perso_Type,
    executerOnPersoTypePersoChange: boolean
  ) {
    if (this.ListeAllDocumentContratIsLoadet) {
      this.exist = false;
      this.listeTypeContratPerso = [];
      this.listeTypeContratPersoBrutIsLoadet = false;

      this.generalService
        .rechercheTable(globalUrls.urlpersocontrat + '&val=' + Perso_Type)
        .subscribe((data) => {
          this.exist = true;
          this.listeTypeContratPersoBrut = data;
          this.listeTypeContratPerso = data.PersoContrat;
          this.listeTypeContratPersoBrutIsLoadet = true;
          if (executerOnPersoTypePersoChange)
            this.onPersoTypePersoChange(this.data.Perso_TypePerso);
        });
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  setNameDocContratToListeTypeContrat(listeTypeContratPerso) {
    for (var i = 0; i < listeTypeContratPerso.length; i++) {
      if (!this.generalService.isNotEmpty(this.data.Perso_TypePerso))
        this.data.Perso_TypePerso = '';
      if (
        !this.generalService.isNotEmpty(
          listeTypeContratPerso[i].PersoContrat_Type
        )
      )
        listeTypeContratPerso[i].PersoContrat_Type = '';
      var Contrat_Partiel = this.ListeAllDocumentContrat.find((doc) => {
        return (
          doc.File_Groupe == this.data.Perso_TypePerso.toString() &&
          doc.File_Key ==
            listeTypeContratPerso[i].PersoContrat_Type.toString() &&
          doc.File_Lien == '1'
        );
      });
      var Contrat_Plein = this.ListeAllDocumentContrat.find((doc) => {
        return (
          doc.File_Groupe == this.data.Perso_TypePerso.toString() &&
          doc.File_Key ==
            listeTypeContratPerso[i].PersoContrat_Type.toString() &&
          doc.File_Lien == '2'
        );
      });

      if (Contrat_Plein == undefined)
        Contrat_Plein = { File_Text: 'Aucun document' };
      listeTypeContratPerso[i].PersoContrat_Plein = Contrat_Plein.File_Text;

      if (Contrat_Partiel == undefined)
        Contrat_Partiel = { File_Text: 'Aucun document' };
      listeTypeContratPerso[i].PersoContrat_Partiel = Contrat_Partiel.File_Text;
      // }
      listeTypeContratPerso[i].PersoUploadContrat_Plein = 'cloud_upload';
      listeTypeContratPerso[i].PersoUploadContrat_Partiel = 'cloud_upload';
    }
    return listeTypeContratPerso;
  }
  getListeAllDocumentContrat(
    setNameDocContratToListeTypeContrat: boolean,
    getAllContrat: boolean
  ) {
    this.ListeAllDocumentContrat = [];
    this.ListeAllDocumentContratIsLoadet = false;
    this.generalService
      .rechercheTable(globalUrls.urlListeAllDocumentContrat)
      .subscribe((listeAllDocumentContrat) => {
        this.ListeAllDocumentContrat = listeAllDocumentContrat;
        this.ListeAllDocumentContratIsLoadet = true;
        if (setNameDocContratToListeTypeContrat) {
          this.setNameDocContratToListeTypeContrat(this.listeTypeContratPerso);
          this.listeContratComponen.setDataSource(this.listeTypeContratPerso);
        }
        if (getAllContrat) this.getAllContrat(true);
      });
  }
  modifier() {
    this.exist = false;
    this.listBtnContrat[0].disabled = true;
    for (var i = 0; i < this.listeTypeContratPerso.length; i++) {
      if (this.listeTypeContratPerso[i].PersoContrat_Fin)
        this.listeTypeContratPerso[i].PersoContrat_Fin = 1;
      else this.listeTypeContratPerso[i].PersoContrat_Fin = 0;
    }
    this.enregistrer(this.listeTypeContratPersoBrut);
    if (this.initDocPersoContrat_Partiel != undefined) {
      this.enregistrerDocPersoContrat(
        this.initDocPersoContrat_Partiel,
        'Partiel'
      );
    }
    if (this.initDocPersoContrat_Plein != undefined) {
      this.enregistrerDocPersoContrat(this.initDocPersoContrat_Plein, 'Plein');
    }
  }
  enregistrerDocPersoContrat(docContrat, type: string) {
    this.disabledTypeColl = true;
    var contrat = this.ListeAllDocumentContrat.find((findContrat) => {
      return (
        findContrat.File_Groupe == this.data.Perso_TypePerso.toString() &&
        findContrat.File_Key == docContrat.files[0].File_Key &&
        findContrat.File_Lien == docContrat.files[0].File_Lien
      );
    });
    //mode UPDATE
    if (contrat != undefined)
      this.generalService
        .rechercheTable(globalUrls.urlFiles + '&val=' + contrat.File_Id)
        .subscribe((doc) => {
          doc.Files[0].File_Content = docContrat.files[0].File_Content;
          doc.Files[0].File_Text = docContrat.files[0].File_Text;
          this.enregistrerContrat(doc, type);
        });
    else this.enregistrerContrat(docContrat, type);
  }
  enregistrerContrat(contrat, type: string) {
    this.generalService.enregisterTable(contrat).subscribe(
      (data) => {
        this.generalService.dialogSuccess('Document enregistrer', true);
        this.disabledTypeColl = false;
        this.getListeAllDocumentContrat(true, false);
        if (type == 'Partiel') this.initDocPersoContrat_Partiel = undefined;
        else this.initDocPersoContrat_Plein = undefined;
      },
      (err) => {
        this.disabledTypeColl = false;
        this.generalService.dialogSuccess('Document non enregistrer', false);
      }
    );
  }
  enregistrer(Contrat) {
    this.generalService.enregisterTable(Contrat).subscribe(
      (data) => {
        this.exist = true;
        this.disabledBtnAjouter = false;
        this.listBtnContrat[0].disabled = false;
        this.generalService.dialogSuccess('Enregistré', true);
        this.getListeAllDocumentContrat(false, true);
      },
      (err) => {
        this.exist = true;
        this.disabledBtnAjouter = false;
        this.disabledTypeColl = false;
        this.generalService.dialogSuccess('Non enregistré', false);
      }
    );
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'selectRow': {
        this.selectedRow = event.row;
        break;
      }
      case 'modifier': {
        this.modifier();
        break;
      }
      case 'supprimer': {
        this.supprimerContrat(event.row);
        break;
      }
      case 'PersoContrat_Partiel': {
        this.telecharger(event.row, '1');
        break;
      }
      case 'PersoContrat_Plein': {
        this.telecharger(event.row, '2');
        break;
      }

      case 'PersoUploadContrat_Partiel': {
        this.openDialogFile('inputFilePersoContrat_Partiel');
        break;
      }
      case 'PersoUploadContrat_Plein': {
        this.openDialogFile('inputFilePersoContrat_Plein');
        break;
      }
    }
  }
  telecharger(row, File_Lien) {
    var Contrat = this.ListeAllDocumentContrat.find((doc) => {
      return (
        doc.File_Groupe == row.Perso_TypePerso.toString() &&
        doc.File_Key == row.PersoContrat_Type.toString() &&
        doc.File_Lien == File_Lien
      );
    });

    if (Contrat != undefined) {
      this.generalService
        .rechercheTable(globalUrls.urlFiles + '&val=' + Contrat.File_Id)
        .subscribe((data) => {
          const b64Data = data;
          const blob = base64StringToBlob(b64Data.Files[0].File_Content);
          var fileURL = URL.createObjectURL(blob);
          window.URL.revokeObjectURL(fileURL);
          let nav: any = window.navigator;
          if (typeof nav.msSaveBlob !== 'undefined') {
            nav.msSaveBlob(blob, Contrat.File_Text);
            return;
          }
          const blobURL = window.URL.createObjectURL(blob);
          const tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', Contrat.File_Text);
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
          }
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          setTimeout(() => {
            window.URL.revokeObjectURL(blobURL);
          }, 100);
        });
    }
  }
  openDialogFile(idInputFile) {
    if (this.generalService.initDoc != undefined) {
      document.getElementById(idInputFile).click();
    } else {
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
    }
  }
  onChangeImagefile(fileInput, PersoContrat: number) {
    blobToBase64String(fileInput.target.files[0]).then((base64String) => {
      if (PersoContrat == 1) {
        this.setInitDocPersoContrat(
          'initDocPersoContrat_Partiel',
          base64String,
          fileInput.target.files[0].name,
          PersoContrat
        );
      }
      if (PersoContrat == 2) {
        this.setInitDocPersoContrat(
          'initDocPersoContrat_Plein',
          base64String,
          fileInput.target.files[0].name,
          PersoContrat
        );
      }
    });
  }

  setInitDocPersoContrat(
    initDocPersoContrat,
    File_Content,
    File_Text,
    File_Lien
  ) {
    var initDoc = JSON.parse(JSON.stringify(this.generalService.initDoc));
    initDoc.files[0].File_Content = File_Content;
    initDoc.files[0].File_Text = File_Text;
    initDoc.files[0].File_Key = this.selectedRow.PersoContrat_Type;
    initDoc.files[0].File_Type = 'avtContrat';
    initDoc.files[0].File_Groupe = this.data.Perso_TypePerso;
    initDoc.files[0].File_Lien = File_Lien;
    initDoc.files[0].File_Dll = 'jstree-file';
    eval('this.' + initDocPersoContrat + ' = initDoc');
  }
  setPersoContrat_Code() {}
  supprimerContrat(row) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        var deleteFn = this.generalService.supprimerSanMsgConfirm(
          row.PersoContrat_Code,
          'persocontratSup'
        );
        if (deleteFn != null) {
          this.exist = false;
          this.listBtnContrat[1].disabled = true;
          deleteFn.subscribe(
            (data) => {
              this.getListeAllDocumentContrat(false, true);
              this.generalService.dialogSuccess('Elément supprimer', true);
              this.exist = true;
              this.listBtnContrat[1].disabled = false;
            },
            (error) => {
              this.generalService.dialogSuccess('Elément non supprimé', false);
              this.exist = true;
              this.listBtnContrat[1].disabled = false;
            }
          );
        }
      }
      if (result == 'annuler') {
      }
    });
  }
}
